import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const UserAuthRoute = () => {
  const { userToken } = useSelector((state) => state.authReducer);
  const location = useLocation();
  const redirectTo =
    location.state?.from ||
    sessionStorage.getItem("redirectAfterLogin") ||
    "/user";

  return userToken ? <Navigate to={redirectTo} replace /> : <Outlet />;
};

export default UserAuthRoute;
